import { ConfirmModal } from '../../commons/components/ConfirmModal';
import {
  PLANNING_ENTITY_CAMPAIGN,
  PLANNING_ENTITY_CAMPAIGN_DESCRIPTION,
  PLANNING_ENTITY_PROGRAM,
  PLANNING_ENTITY_SOCIAL_POST,
  PLANNING_ENTITY_SOCIAL_POST_DESCRIPTION,
  PlanningEntityType,
} from '../types';
import { DivButton } from '../../commons/components/DivButton';
import { CalendarIcon, CampaignIcon, ChatBalloonIcon } from '../../assets/icons';
import { useState } from 'react';

export const PlanningEntityTypeSelector = (props: {
  showSocialPost: boolean;
  onSelect: (selectedType: PlanningEntityType) => void;
}) => {
  const { showSocialPost, onSelect } = props;
  const [selected, setSelected] = useState(false);
  const onClick = (entityType: PlanningEntityType) => {
    setSelected(true);
    onSelect(entityType);
  };
  if (selected) return null;
  return (
    <ConfirmModal
      title="Create new..."
      className="planning-entity-type-selector__confirm-dialog"
      footer={{ type: 'hide', cancel: () => {} }}
    >
      <div className="planning-entity-type-selector__container">
        {showSocialPost && (
          <DivButton
            icon={<ChatBalloonIcon />}
            text="Social Post"
            onClick={() => onClick(PLANNING_ENTITY_SOCIAL_POST)}
            info={PLANNING_ENTITY_SOCIAL_POST_DESCRIPTION}
          />
        )}
        <DivButton
          icon={<CalendarIcon />}
          text="Program"
          onClick={() => onClick(PLANNING_ENTITY_PROGRAM)}
        />
        <DivButton
          icon={<CampaignIcon />}
          text="Campaign"
          onClick={() => onClick(PLANNING_ENTITY_CAMPAIGN)}
          info={PLANNING_ENTITY_CAMPAIGN_DESCRIPTION}
        />
      </div>
    </ConfirmModal>
  );
};
